import { Link } from "react-router-dom";
import { Linkedin, Instagram, Twitter, Mail } from "lucide-react";
import { BRAND } from "@/data/content";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="bg-gl-bg2 border-t border-gl-gold/15"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex flex-col leading-none mb-5">
            <span className="font-serif-display text-3xl text-gl-text">
              GoodLiving
            </span>
            <span className="text-xs uppercase tracking-[0.45em] text-gl-gold mt-1">
              Strategy
            </span>
          </div>
          <p className="text-gl-text2 max-w-md font-light leading-relaxed">
            International real estate investment consulting. We build the
            financial habits and creative financing strategies that turn global
            property goals into closed deals.
          </p>
          <div className="flex gap-4 mt-7">
            {[
              { Icon: Linkedin, label: "linkedin" },
              { Icon: Instagram, label: "instagram" },
              { Icon: Twitter, label: "twitter" },
              { Icon: Mail, label: "email" },
            ].map(({ Icon, label }) => (
              <a
                key={label}
                href="#"
                data-testid={`social-${label}`}
                aria-label={label}
                className="w-10 h-10 border border-gl-gold/30 flex items-center justify-center text-gl-text2 hover:text-gl-bg hover:bg-gl-gold transition-colors duration-300"
              >
                <Icon size={18} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-gl-gold text-sm uppercase tracking-[0.25em] mb-5">
            Explore
          </h4>
          <ul className="space-y-3 text-gl-text2">
            <li><Link to="/about" className="hover:text-gl-gold transition-colors">About</Link></li>
            <li><Link to="/services" className="hover:text-gl-gold transition-colors">Services</Link></li>
            <li><Link to="/success-stories" className="hover:text-gl-gold transition-colors">Success Stories</Link></li>
            <li><Link to="/contact" className="hover:text-gl-gold transition-colors">Book Consultation</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-gl-gold text-sm uppercase tracking-[0.25em] mb-5">
            Legal
          </h4>
          <ul className="space-y-3 text-gl-text2">
            <li><Link to="/privacy" className="hover:text-gl-gold transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-gl-gold transition-colors">Terms &amp; Conditions</Link></li>
            <li><Link to="/admin" data-testid="footer-admin-link" className="hover:text-gl-gold transition-colors">Admin Portal</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-gl-gold/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-gl-text2/70 text-sm">
            © {year} {BRAND}. All rights reserved.
          </p>
          <p className="text-gl-text2/50 text-xs tracking-wide">
            Strategic guidance only. Not financial, legal, or tax advice.
          </p>
        </div>
      </div>
    </footer>
  );
}
